import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import types from "./types";

export const printersFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "printersFetch",
        { config },
        undefined,
        undefined,
        "print",
    );

export const printersGet = (id: number, config?: AxiosRequestConfig) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "printersGet",
        { config, url: { id } },
        undefined,
        undefined,
        "print",
    );

export const printersTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});
